
import { MultipleChoiceStep } from "@/components/onboarding/MultipleChoiceStep";

interface ArtistQuestionProps {
  value: string;
  onChange: (value: string) => void;
}

export const ArtistQuestion = ({ value, onChange }: ArtistQuestionProps) => {
  return (
    <MultipleChoiceStep
      title="Are you a practicing artist?"
      choices={[
        { id: "artist", label: "Yes" },
        { id: "member", label: "No" }
      ]}
      selected={value}
      onChange={onChange}
    />
  );
};
